import { ErrorBanner } from 'ui/banner';
import { getFromNow } from 'utils/date';
import { ResourceSelect } from 'modules/workflowNodeEditors/editorComponents/ResourceSelect';
import { useMessageChannels } from '../StartNodeEditor.hooks';
import { ResourceComponentProps } from './types';

const displayText = {
  errorTitle: 'Something went wrong...',
  errorCaption: 'Could not fetch channels',
};

export const ResourceChannelSelect = ({
  onChange,
  value,
  placeholder,
  isError,
  noResourceHelpText,
  isDisabled,
  ...props
}: ResourceComponentProps) => {
  const { messageChannels, didError, isLoading } = useMessageChannels();

  if (!isLoading && didError) {
    return <ErrorBanner title={displayText.errorTitle}>{displayText.errorCaption}</ErrorBanner>;
  }

  return (
    <ResourceSelect
      {...props}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      options={messageChannels.map((channel) => ({
        id: channel.id.toString(),
        value: channel.id.toString(),
        label: channel.name,
        doubleLine: `ID: ${channel.id} | Updated ${getFromNow(channel.updatedAt)}`,
      }))}
      placeholder={placeholder}
      isError={isError}
      noResourceHelpText={noResourceHelpText ?? ''}
      isDisabled={isDisabled}
    />
  );
};
